var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"back-icon"},[_vm._v("←")]),_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }